import { SeverityOrder } from '../../../enums/damage/damage-severity.enum';
export class SmartphotoImage {
    uuid;
    url;
    caption;
    type;
    coordinates;
    takePhotoAt;
    severity;
    masks;
    otherMasks;
    uploadedBy;
    hasDamages;
    alerts = [];
    constructor(image, alerts = [], mainDamages = [], otherDamages = []) {
        const allDamages = [...mainDamages, ...otherDamages];
        this.alerts = alerts;
        this.uuid = image.uuid;
        this.url = image.url;
        this.caption = image.caption?.trim() !== '' ? image.caption : undefined;
        this.type = image.type;
        this.coordinates = image.coordinates;
        this.takePhotoAt = image.takePhotoAt;
        this.hasDamages = allDamages.length > 0;
        this.uploadedBy = image.uploadedBy;
        this.masks = mainDamages.map(({ maskFilename }) => maskFilename).filter((m) => Boolean(m));
        this.otherMasks = otherDamages.map(({ maskFilename }) => maskFilename).filter((m) => Boolean(m));
        const severities = allDamages.map(({ modified_severity, original_severity }) => modified_severity ?? original_severity);
        const [firstMatchingSeverity] = SeverityOrder.filter((severity) => severities.includes(severity));
        this.severity = firstMatchingSeverity;
    }
    getFileName() {
        const [url = ''] = this.url.split('?');
        const [extension] = url.split('.').reverse();
        return `${this.caption ?? 'image'}.${extension}`;
    }
}
